import { render, staticRenderFns } from "./dialogReviewPlatformAdd.vue?vue&type=template&id=46bbcdab"
import script from "./dialogReviewPlatformAdd.vue?vue&type=script&lang=js"
export * from "./dialogReviewPlatformAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports